export const detailsWidth = 220;
